import React from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { GoogleLogo, ShieldCheck } from "@phosphor-icons/react";

export default function AdminLoginPage() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="App">
      <Navbar />

      <section className="max-w-3xl mx-auto px-6 md:px-12 py-24" data-testid="admin-login-page">
        <div className="label-uppercase">Admin · restricted</div>
        <h1 className="h1 text-5xl md:text-6xl mt-4">Sign in to manage your portfolio.</h1>
        <p className="mt-6 text-lg text-[var(--text-secondary)] max-w-xl">
          Admin access is restricted to the property owner's Google account. Sign in to view inquiries
          and update property details.
        </p>

        <div className="mt-12 border border-[var(--border-subtle)] p-8 max-w-lg">
          <div className="flex items-center gap-2 text-[var(--text-tertiary)]">
            <ShieldCheck size={18} /> <span className="label-uppercase">Single sign-on</span>
          </div>
          <h2 className="h3 text-2xl mt-3">Continue with Google</h2>
          <p className="mt-2 text-sm text-[var(--text-secondary)]">
            Only the configured admin email may access the dashboard.
          </p>
          <button onClick={handleLogin} className="btn-primary w-full justify-center mt-6" data-testid="admin-google-login-button">
            <GoogleLogo size={18} weight="bold" /> Continue with Google
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
